import React from 'react';
import {
  KeyRound,
  Plus,
  Lock,
  Info,
  Webhook,
  Key,
  Shield
} from 'lucide-react';
import { Button } from '../../../../components/ui/button';
import { Badge } from '../../../../components/ui/badge';

const PlatformPrivateIntegrationsPage = () => {
  return (
    <div className="min-h-screen bg-[#0B1F18] p-8" data-testid="platform-private-integrations-page">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-rose-500 to-rose-600 flex items-center justify-center">
            <KeyRound className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-white">Private Integrations</h1>
            <p className="text-[#93AE9F] text-sm">
              Secure API connections for internal system use
            </p>
          </div>
        </div>
        <Button
          disabled
          className="bg-zinc-700 text-zinc-400 cursor-not-allowed"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add Integration
        </Button>
      </div>

      {/* Coming Soon Card */}
      <div className="bg-[rgba(10,38,28,0.6)] border border-[rgba(142,218,182,0.12)] rounded-xl p-12 text-center">
        <div className="w-16 h-16 rounded-2xl bg-zinc-800 flex items-center justify-center mx-auto mb-6">
          <Lock className="w-8 h-8 text-zinc-500" />
        </div>
        <h2 className="text-xl font-bold text-white mb-2">Private Integrations Coming Soon</h2>
        <p className="text-[#93AE9F] max-w-md mx-auto mb-6">
          This section will allow you to create secure, private API integrations for 
          internal systems, custom webhooks, and enterprise connections.
        </p>
        <Badge className="bg-amber-500/20 text-amber-400 border-0">In Development</Badge>
      </div>

      {/* Planned Features */}
      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-[rgba(10,38,28,0.4)] border border-[rgba(142,218,182,0.08)] rounded-xl p-6">
          <div className="w-10 h-10 rounded-lg bg-zinc-800 flex items-center justify-center mb-4">
            <Webhook className="w-5 h-5 text-zinc-500" />
          </div>
          <h3 className="font-semibold text-white mb-2">Custom Webhooks</h3>
          <p className="text-sm text-[#93AE9F]">
            Create custom webhook endpoints for receiving data from external systems.
          </p>
        </div>
        
        <div className="bg-[rgba(10,38,28,0.4)] border border-[rgba(142,218,182,0.08)] rounded-xl p-6">
          <div className="w-10 h-10 rounded-lg bg-zinc-800 flex items-center justify-center mb-4">
            <Key className="w-5 h-5 text-zinc-500" />
          </div>
          <h3 className="font-semibold text-white mb-2">API Key Management</h3>
          <p className="text-sm text-[#93AE9F]">
            Generate and manage secure API keys for third-party access.
          </p>
        </div>
        
        <div className="bg-[rgba(10,38,28,0.4)] border border-[rgba(142,218,182,0.08)] rounded-xl p-6">
          <div className="w-10 h-10 rounded-lg bg-zinc-800 flex items-center justify-center mb-4">
            <Shield className="w-5 h-5 text-zinc-500" />
          </div>
          <h3 className="font-semibold text-white mb-2">OAuth Connections</h3>
          <p className="text-sm text-[#93AE9F]">
            Configure OAuth 2.0 connections for enterprise SSO and integrations.
          </p>
        </div>
      </div>

      {/* Info Box */}
      <div className="mt-6 p-4 bg-blue-500/10 border border-blue-500/20 rounded-xl">
        <div className="flex items-start gap-3">
          <Info className="w-5 h-5 text-blue-400 flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-semibold text-blue-400 mb-1">About Private Integrations</h4>
            <p className="text-sm text-blue-300/80">
              Private integrations provide secure, encrypted connections for sensitive 
              data flows. Unlike public integrations, these are not exposed to agencies 
              and are managed exclusively by Platform Owners.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlatformPrivateIntegrationsPage;
